import React, { useEffect, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { usePhoneNumberState } from '../../utils/hooks'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { useFocusedErrorProps } from '@linqpal/common-frontend/src/hooks'
import CommonInput from '../atoms/builder-2.0/CommonInput'
import { useTranslation } from 'react-i18next'
import { KeyboardType } from '@linqpal/models/src/dictionaries'

const styles = StyleSheet.create({
  inputsWrapper: {
    marginBottom: 16,
    flex: 1,
  },
})

const PhoneNumberInput = ({
  editable = true,
  containerStyle = {},
  style = {},
  value,
  onChangeText,
  customStyle = {},
  ...props
}) => {
  const { t } = useTranslation('errors')
  const [phoneNumber, onChangePhoneNumber, isValid] = usePhoneNumberState(
      value,
      onChangeText,
    ),
    /**
     * expecting 14: '(999) 999 9999' by default
     */ [maxLength, setMaxLength] = useState(14),
    errorProps = useFocusedErrorProps(
      phoneNumber.length && !isValid ? t('not-valid-number') : '',
    )

  useEffect(() => {
    switch (phoneNumber[0]) {
      case '+':
        /**
         * Expecting 15: +1 999 999 9999
         */
        setMaxLength(15)
        break
      case '1':
        /**
         * Expecting 16: 1 (999) 999-9999
         */
        setMaxLength(16)
        break
      default:
        /**
         * Expecting 14: (999) 999 9999
         */
        setMaxLength(14)
    }
  }, [phoneNumber])

  return (
    <View
      style={composeStyle(
        { ...styles.inputsWrapper, customStyle },
        containerStyle,
      )}
    >
      <CommonInput
        {...errorProps}
        value={phoneNumber}
        onChangeText={onChangePhoneNumber}
        editable={editable}
        maxLength={maxLength}
        autoComplete="tel"
        keyboardType={KeyboardType.NumberPad}
        highlight={errorProps.error}
        {...props}
      />
    </View>
  )
}

export default PhoneNumberInput
